import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAlert } from 'contexts/AlertContext';
import { ProfileImageSection, ProfileForm, AccountSection } from 'components/settings';
import './Profile.css';

export const Profile: React.FC = () => {
    const navigate = useNavigate();
    const { showAlert, showConfirm } = useAlert();
    const [nickname, setNickname] = useState('김위즈');
    const [statusMessage, setStatusMessage] = useState('오늘도 화이팅!');
    const [email] = useState('wiz@mo2.com');

    const handleSave = async () => {
        // TODO: 프로필 저장 로직 구현
        await showAlert({ message: '프로필이 저장되었습니다.' });
        navigate(-1);
    };

    const handleWithdraw = async () => {
        const confirmed = await showConfirm({
            message: '정말로 회원탈퇴 하시겠습니까?',
            confirmText: '탈퇴'
        });
        if (confirmed) {
            // TODO: 회원탈퇴 로직 구현
            navigate('/login');
        }
    };

    const handleChangePassword = () => {
        navigate('/settings/change-password');
    };

    return (
        <div className="profile-wrapper">
            <div className="profile-header">
                <button className="back-button" onClick={() => navigate('/settings')}>
                    ←
                </button>
                <h1 className="profile-title">프로필 설정</h1>
                <button className="save-button" onClick={handleSave}>
                    저장
                </button>
            </div>

            <div className="profile-content">
                <ProfileImageSection
                    nickname={nickname}
                    email={email}
                />

                <ProfileForm
                    nickname={nickname}
                    statusMessage={statusMessage}
                    onNicknameChange={setNickname}
                    onStatusMessageChange={setStatusMessage}
                />

                <AccountSection
                    email={email}
                    onChangePassword={handleChangePassword}
                    onWithdraw={handleWithdraw}
                />
            </div>
        </div>
    );
};
